module.exports = __webpack_public_path__ + "static/media/lightIcon.a8db8bb6.svg";